<template>
  <div>
    <div class="schedule-on-air-container" v-if="isShowing()">
      <div class="schedule-on-air-item"
        v-for="indexOfDay in filterRecurrentDaysOfWeek"
        :key="indexOfDay">
        {{getDay(indexOfDay)}}
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import dateFormetter from '@/utils/dateFormatter';

export default {
  mixins: [dateFormetter],
  props: {
    recurrentDaysOfWeek: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filterRecurrentDaysOfWeek() {
      return _.sortBy(this.recurrentDaysOfWeek);
    },
  },
  methods: {
    isShowing() {
      return this.recurrentDaysOfWeek && this.recurrentDaysOfWeek.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.schedule-on-air-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: $spacer * 0.25;

  .schedule-on-air-item {
    margin-right: $spacer * 0.5;

    &:not(:last-child)::after {
      content: ', ';
    }
  }
}
</style>
